import { render, staticRenderFns } from "./PopupWin.vue?vue&type=template&id=5dcfc242&"
import script from "./PopupWin.vue?vue&type=script&lang=js&"
export * from "./PopupWin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports